import Flickity from "flickity";

const ROOT_SELECTOR = ".js-testimonials";
const CAROUSEL_SELECTOR = ".js-testimonials-carousel";

export function init() {
	Array.from(document.querySelectorAll(ROOT_SELECTOR)).forEach((e) =>
		create(e),
	);
}

function create(element) {
	let carouselElement = element.querySelector(CAROUSEL_SELECTOR);

	if (!carouselElement) {
		return;
	}

	new Flickity(carouselElement, {
		prevNextButtons: false,
		arrowShape: "M30.7,20.3l-29.3,30l29.3,30 M100.7,50.3H1.4",
	});
}
